module.exports = __webpack_public_path__ + "static/2018_PFB_Financials_v05-67d41496cea8523ba9fd7d55f66a0b1a.pdf";